const VIEWPORT_PAD = 8;

/**
 * Place a floating panel below the anchor. Never flips above the trigger.
 */
export function computeFloatingPanelBelow(anchorEl, { minWidth = 256, gap = 8 } = {}) {
  if (!anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const width = Math.max(rect.width, minWidth);
  let left = rect.left;
  const top = rect.bottom + gap;

  if (left + width > window.innerWidth - VIEWPORT_PAD) {
    left = window.innerWidth - width - VIEWPORT_PAD;
  }
  if (left < VIEWPORT_PAD) {
    left = VIEWPORT_PAD;
  }

  return { top, left, width, gap };
}
